import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Button,
  Segment,
  Header,
  Accordion,
  Icon,
} from 'semantic-ui-react';
import LoanAmount from './LoanAmount';
import CurrencySymbol from './CurrencySymbol';
import {
  isCommitmentVehicle,
  isCommitmentHouse,
  isCommitmentCreditCard,
  isCommitmentPersonal,
  isCommitmentOther,
} from '../constants/buyerCommitments';

export default class BuyerCheckResult extends Component {
  static propTypes = {
    data: PropTypes.shape({
      _ccris: PropTypes.object,
      _mhub_check: PropTypes.object,
      loan_eligible_ranges: PropTypes.object,
      income_net: PropTypes.string,
      dsr_score: PropTypes.number,
    }),
    isMobile: PropTypes.bool,
    projectCurrencies: PropTypes.arrayOf(PropTypes.object),
  }

  constructor(props) {
    super(props);
    this.state = {
      showCommitment: false,
    };
  }

  getCreditHistory = (brickScore) => {
    switch (brickScore) {
      case 5:
        return 'Excellent';
      case 4:
        return 'Good';
      case 3:
        return 'Average';
      case 2:
        return 'Below Average';
      case 1:
        return 'Poor';
      default:
        return '-';
    }
  }

  handleToggleCommitment = () => {
    const { showCommitment } = this.state;
    this.setState({ showCommitment: !showCommitment });
  }

  isEligible = () => {
    const { data } = this.props;
    const { loan_eligible_ranges: loanEligibleRanges, _mhub_check: mhubCheck } = data;
    if (loanEligibleRanges && mhubCheck) {
      const { loan_amount: loanAmount } = loanEligibleRanges;
      const { brick_score: brickScore } = mhubCheck;
      if (loanAmount > 0 && brickScore > 1) {
        return true;
      }
    }
    return false;
  }

  renderEligibleLoanAmount = () => {
    const { data, projectCurrencies } = this.props;
    const { loan_eligible_ranges: loanEligibleRanges } = data;
    const isEligible = this.isEligible();
    if (!isEligible) {
      return (
        <Segment className="eligible-loan-amount not-eligible">
          <p>Eligible Loan Amount</p>
          <Header as="h2">Not Eligible</Header>
        </Segment>
      );
    }
    return (
      <Segment className="eligible-loan-amount">
        <p>Eligible Loan Amount</p>
        <Header as="h2">
          <LoanAmount
            projectCurrencies={projectCurrencies}
            format="0,000,000"
            amount={loanEligibleRanges ? (loanEligibleRanges.min_loan_amount || 0) / 100 : 0}
            prefix={<CurrencySymbol />}
          />
          &nbsp;-&nbsp;
          <LoanAmount
            projectCurrencies={projectCurrencies}
            format="0,000,000"
            amount={loanEligibleRanges ? (loanEligibleRanges.max_loan_amount || 0) / 100 : 0}
            prefix={<CurrencySymbol />}
          />
        </Header>
      </Segment>
    );
  }

  renderCommitmentList = (title, selector) => {
    const { projectCurrencies, data } = this.props;
    const { _ccris: ccris } = data;
    let amount = 0;
    if (selector != null) {
      const list = ccris.commitments.filter(selector);
      if (list && list.length > 0) {
        amount = list.reduce((a, c) => {
          const {
            installment_amount: installmentAmount,
            commitment_monthly: commitmentMonthly,
          } = c;
          const installment = installmentAmount || 0;
          const monthly = commitmentMonthly || 0;
          const monthlyRepayment = (installment > 0 ? installment : monthly);
          return a + monthlyRepayment;
        }, 0);
      }
    }
    return (
      <Grid.Row key={title}>
        <Grid.Column>{title}</Grid.Column>
        <Grid.Column textAlign="right">
          <LoanAmount
            projectCurrencies={projectCurrencies}
            amount={amount ? (amount || 0) : 0}
            format="0,000,000"
          />
        </Grid.Column>
      </Grid.Row>
    );
  }

  renderCommitmentDetails = () => {
    const { showCommitment } = this.state;
    const { projectCurrencies, data } = this.props;
    const { _ccris: ccris } = data;
    if (ccris) {
      return (
        <Accordion>
          <Accordion.Title
            as={Button}
            basic
            compact
            index={0}
            className="show-commitment"
            active={showCommitment}
            onClick={this.handleToggleCommitment}
          >
            <Icon name={showCommitment ? 'chevron up' : 'chevron down'} />
            {showCommitment ? 'Hide' : 'Show'} Monthly Commitment
          </Accordion.Title>
          <Accordion.Content active={showCommitment}>
            <Grid className="commitment" verticalAlign="middle">
              <Grid.Row className="header">
                <Grid.Column>Details</Grid.Column>
                <Grid.Column textAlign="right">RM</Grid.Column>
              </Grid.Row>
              {this.renderCommitmentList('Car Loan', isCommitmentVehicle)}
              {this.renderCommitmentList('Home Loan', isCommitmentHouse)}
              {this.renderCommitmentList('Student Loan', c => c.is_ptptn)}
              {this.renderCommitmentList('Credit Card', isCommitmentCreditCard)}
              {this.renderCommitmentList('Personal Loan', isCommitmentPersonal)}
              {this.renderCommitmentList('Others', isCommitmentOther)}
              <Grid.Row className="total-amount">
                <Grid.Column>Total</Grid.Column>
                <Grid.Column textAlign="right">
                  <LoanAmount
                    projectCurrencies={projectCurrencies}
                    amount={ccris ? (ccris.total_commitment || 0) / 100 : 0}
                    format="0,000,000"
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </Accordion>
      );
    }
    return null;
  }

  render() {
    const { isMobile, projectCurrencies, data } = this.props;
    const {
      _ccris: ccris,
      income_net: incomeNet,
      dsr_score: dsrScore,
      _mhub_check: mhubCheck,
    } = data;
    const { brick_score: brickScore, bankruptcy } = mhubCheck;
    return (
      <div className="buyer-check-result">
        <Segment.Group
          className="dashboard"
          horizontal={!isMobile}
        >
          {this.renderEligibleLoanAmount()}
          <Segment>
            <p>DSR</p>
            <Header as="h2">{dsrScore ? `${dsrScore}%` : '-'}</Header>
          </Segment>
          <Segment>
            <p>MHub Brick Score</p>
            <Header as="h2">{this.getCreditHistory(brickScore)}</Header>
          </Segment>
        </Segment.Group>
        <Grid className="details" columns={2} verticalAlign="bottom">
          <Grid.Row>
            <Grid.Column>Bankruptcy Status:</Grid.Column>
            <Grid.Column textAlign="right">
              {bankruptcy ? 'Yes' : 'No'}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>Nett Income:</Grid.Column>
            <Grid.Column textAlign="right">
              <LoanAmount
                projectCurrencies={projectCurrencies}
                amount={(parseInt(incomeNet, 10) || 0) / 100}
                format="0,000,000"
                prefix={<CurrencySymbol />}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>Monthly Commitment:</Grid.Column>
            <Grid.Column textAlign="right">
              <LoanAmount
                projectCurrencies={projectCurrencies}
                amount={ccris ? (ccris.total_commitment || 0) / 100 : 0}
                format="0,000,000"
                prefix={<CurrencySymbol />}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        {this.renderCommitmentDetails()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BuyerCheckResult.jsx